/* A single responsive player keeps the original desktop/mobile films. */
if (!customElements.get('rm-video')) {
  customElements.define('rm-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.sync = () => {
        this.button.textContent = this.video.paused ? 'Play video' : 'Pause video';
        this.button.setAttribute('aria-label', this.video.paused ? 'Play banner video' : 'Pause banner video');
      };
      this.loadVideo = () => {
        const src = this.mobile.matches && this.dataset.mobile ? this.dataset.mobile : this.dataset.desktop;
        this.button.hidden = !src;
        if (!src) return;
        this.video.src = src;
        if (!this.reduced.matches && !this.userPaused) this.video.play().catch(this.sync);
      };
      this.toggle = () => {
        if (this.video.paused) { this.userPaused = false; this.video.play().catch(this.sync); }
        else { this.userPaused = true; this.video.pause(); }
      };
      this.motionChange = () => { if (this.reduced.matches) this.video.pause(); };
      this.button.addEventListener('click', this.toggle);
      this.video.addEventListener('play', this.sync);
      this.video.addEventListener('pause', this.sync);
      this.mobile.addEventListener('change', this.loadVideo);
      this.reduced.addEventListener('change', this.motionChange);
      this.loadVideo();
    }
    disconnectedCallback() {
      this.video.pause();
      this.button.removeEventListener('click', this.toggle);
      this.video.removeEventListener('play', this.sync);
      this.video.removeEventListener('pause', this.sync);
      this.mobile.removeEventListener('change', this.loadVideo);
      this.reduced.removeEventListener('change', this.motionChange);
    }
  });
}
